import React from 'react';
import PopoverMui, { PopoverProps } from '@material-ui/core/Popover';

export const Popover: React.FC<PopoverProps> = ({ children, ...rest }) => {
	return <PopoverMui {...rest}>{children}</PopoverMui>;
};
